import { useGenericFieldsData } from 'containers/GenericFieldsHandlingLayer/context';
import { useData } from 'containers/AdditionalDataStorage/context';
import { getSingleNumberValue, getSingleOption, getSingleStringValue } from 'api/cart/utils';
import { mapProjectFieldsToProjectDanflossCart } from '@danfloss/api/cart/iframe';
import { toFixedByLengthType } from '@danfloss/views/AssemblyLengthView/utils';
import { LengthType } from 'common/types/additional';
import { IFormValues } from 'common/components/FormHF/types';
import { DanflossProjectFields } from '@danfloss/containers/project-fields';

export const useSummary = () => {
  const { fields: currentFields } = useGenericFieldsData<IFormValues<DanflossProjectFields>>();
  const additionalData = useData();

  const hose = getSingleOption(currentFields.hoseProduct?.value?.selected);
  const fitting1 = getSingleOption(currentFields.fitting1Product?.value?.selected);
  const fitting2 = getSingleOption(currentFields.fitting2Product?.value?.selected);
  const testing = getSingleOption(currentFields.testingConfiguration?.value?.selected);
  const accessories = getSingleOption(currentFields.accessoryProduct?.value?.selected);
  const angleOfRotationField = currentFields.angleOfRotation;
  const isAngleFieldAvailable = !!angleOfRotationField && angleOfRotationField.status !== 'disabled';
  const angle = isAngleFieldAvailable
    ? getSingleNumberValue(angleOfRotationField?.value?.selected)
    : undefined;
  const { generatedConfigId } = mapProjectFieldsToProjectDanflossCart(currentFields, additionalData);
  const quantityRaw = getSingleStringValue(currentFields.quantity?.value?.selected);
  const quantity = quantityRaw ? parseInt(quantityRaw, 10) : 1;
  const notes = getSingleStringValue(currentFields.notes?.value?.selected);


  const lengthInInches = getSingleNumberValue(currentFields.assemblyLength?.value?.selected)!;
  const lengthInFeet = toFixedByLengthType(lengthInInches, LengthType.inches, LengthType.feet);

  const lengthType = getSingleStringValue(currentFields.lengthType?.value?.selected) as LengthType || additionalData.lengthType;
  const customerPartNumber = getSingleStringValue(currentFields.customerSerialNumber?.value?.selected)!;

  return {
    hose,
    fitting1,
    fitting2,
    accessories,
    customerPartNumber,
    lengthInFeet,
    testing,
    lengthInInches,
    lengthType,
    angle,
    generatedConfigId,
    quantity,
    notes,
  };
};
export type Summary = ReturnType<typeof useSummary>;
